module.exports = __webpack_public_path__ + "img/tsr-generic.bc141aff.jpeg";